import * as Epics from './loading-manager.epic';
import Container from './loading-manager.container';

export { Epics, Container };

export default Container;
